import { DataCard } from 'components/DataCardComponent/styles'
import ReactEcharts from "echarts-for-react";

//options is required
export default function BarGraph({ text, containerStyle, option, style }: { text: string, containerStyle?: string, option: any, style?: object }) {
    return (
        <DataCard data-testid="test-empty-card" className={containerStyle}>
            <div className='flex flex-col w-full relative'>
                <span className='text-darkGray text-base font-semibold pt-1'>{text}</span>
                <ReactEcharts option={option} style={style} />
            </div>
        </DataCard>
    )
}
